<template>
    <div class="cash-withdrawal" style="padding-top: 1rem">
        <navTitle :title="$router.app._route.query.ti ? $router.app._route.query.ti : $t('message.withdrawal.title')"
                  path="/user"></navTitle>
        <div v-if="is_request===true">
            <div class="isnull" v-if="showTips === true">
                {{$t('message.withdrawal.link_now_tip')}}
                <div class="isnull-btn" @click="$router.push({ path: '/user/myPay' })">
                    {{$t('message.withdrawal.link_now')}}
                </div>
            </div>

            <div v-if="showTips === false">
                <div class="row-wrap">
                    <!--<div class="row-T1">{{$t('message.withdrawal.withdrawal_account')}}</div>
                    <div class="row">
                        <div class="row-name">{{$t('message.withdrawal.phone')}}</div>
                        <input class="input" v-model="phone" readonly/>
                    </div>
                    <div class="row">
                        <div class="row-name">{{$t('message.my_pay.bank_name')}}</div>
                        <input class="input" v-model="bank_name" readonly/>
                    </div>-->
                    <div class="row">
                        <div class="row-name">{{$t('message.my_pay.bank_account')}}</div>
                        <input class="input" v-model="bank_account_" readonly/>
                    </div>
                    <div class="row">
                        <!--                    <div class="row-name">{{$t('message.my_pay.beneficiary_name')}}</div>-->
                        <div class="row-name">tên tài khoản</div>
                        <input class="input" v-model="bank_account_name_" readonly/>
                    </div>
                </div>
                <div class="row-T1">{{$t('message.withdrawal.withdraw_amount')}}</div>
                <div class="value-item">
                    <div>
                        <div class="money-switch" style="padding-bottom: 0px">
                            <div class="switch-item" :class="switch_index==index?'switch-click':''"
                                 v-for="(item,index) in money_switch" v-key="index"
                                 @click="switchItem(item,index)">
                                {{item|MoneyFormat}}₫
                            </div>
                        </div>
                    </div>
                    <!--                <div class="max">{{$t('message.withdrawal.balance')}}:₫{{ parseInt(now_money)|MoneyFormat }} - <i style="color: orangered">₫{{(parseFloat(this.post.money) - parseFloat(this.realFree))|MoneyFormat}}</i></div>-->
                    <div class="max">{{$t('message.withdrawal.balance')}} : {{ parseInt(now_money)|MoneyFormat }}₫ -
                        {{post.money|MoneyFormat}}₫
                    </div>
                </div>
                <div class="row-info" v-if="!showError">
                    {{$t('message.withdrawal.processing_fee')}}:{{ realFree
                    }}₫，{{$t('message.withdrawal.actual_amount')}} :{{ realPrice }}₫<br/>
                    <!--                Processing fee:USDT {{ (realFree/80).toFixed(2) }}，<br/>actual amount :USDT {{ (realPrice/80).toFixed(2) }}-->
                </div>
                <div class="row-error" v-else>{{errorMsg}}</div>

                <div class="submit bg-color-blue" @click="submitted">{{$t('message.withdrawal.title')}}</div>

                <div id="forPop" v-if="yz_pwd" @click="bgClose"></div>
                <div v-if="yz_pwd" class="set-pwd">
                    <div class="tx-pwd-title">Mật khẩu rút tiền</div>
                    <div class="row">
                        <input type="password" class="input" placeholder="mật khẩu mở khóa" v-model="withdraw_pwd"/>
                    </div>
                    <div class="set-tx-pwd-btn bg-color-blue" @click="inputPassword">Chắc chắn rồi</div>
                    <div class="set-tx-pwd-btn bg-qx" @click="bgClose">Khép kín</div>
                    <div style="clear: both"></div>
                    <div class="forget-password" @click="forgetPassword">Quên mật khẩu</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        getUserInfo,
        withdraw_fee,
        user_withdraw, getCashList, getWithdrawPasswordFlag
    } from "../../../api/user";
    import navTitle from "@components/navTitle";

    export default {
        name: "UserCash",
        components: {navTitle},
        props: {},
        data: function () {
            return {
                // money_switch: [120000, 200000, 500000, 1000000, 2000000, 5000000, 10000000, 20000000],
                money_switch: [300000, 500000, 1000000, 2000000, 5000000, 10000000],
                switch_index: 1,
                userInfo: {
                    now_money: 0
                },
                realFree: 0,
                realPrice: 0,
                now_money: 0,
                cash_id: "",

                bank_account_name: "",
                bank_account_name_: "",
                phone: "",
                bank_account: "",
                bank_account_: "",
                bank_name: "",

                post: {
                    money: 500000
                },
                minPrice: 0,
                showTips: true,
                bomb_submit: false,
                is_request: false,
                showError: false,
                errorMsg: '',
                withdraw_pwd: '',
                yz_pwd: false,
                is_set_pwd: false
            };
        },
        mounted: function () {
            this.getUserInfo()
            this.getBindCashList()
            this.getWithdrawPassword()
            this.getwithdraw_fee()
        },
        methods: {
            getUserInfo() {
                getUserInfo().then(res => {
                    // this.post.phone = res.data.phone.slice(2)
                    this.userInfo.now_money = res.data.now_money
                    this.now_money = res.data.now_money
                })
            },
            setStr(str, num) {
                return str.substring(0, num) + "****" + str.substr(str.length - num);
            },
            switchItem(money, index) {
                this.switch_index = index
                this.post.money = money
                this.getwithdraw_fee()
            },
            getwithdraw_fee() {
                withdraw_fee({money: this.post.money}).then(res => {
                    // console.log('getwithdraw_fee_usdt', res)
                    this.realPrice = res.data.money;
                    this.realFree = res.data.fee;
                }).catch(res => {
                    this.showError = true
                    this.errorMsg = res.msg
                })
            },
            getBindCashList() {
                getCashList().then(res => {
                    // console.log(res)
                    const list = res.data.data
                    if (list.length > 0) {
                        this.showTips = false
                        this.minPrice = res.data.user_withdraw_limit
                        this.cash_id = list[0].id
                        this.phone = list[0].phone
                        this.bank_name = list[0].bank_name
                        this.bank_account = list[0].bank_account
                        this.bank_account_name = list[0].bank_account_name
                        this.bank_account_ = this.setStr(list[0].bank_account, 2)
                        this.bank_account_name_ = this.setStr(list[0].bank_account_name, 2)
                    }
                    this.is_request = true
                })
            },
            async submitted() {
                let cash_id = this.cash_id,
                    money = this.post.money,
                    that = this;

                if (cash_id === "") {
                    return that.$dialog.message(this.$t('message.withdrawal.msg_withdrawal_account'));
                }
                if (!that.bank_account_name) {
                    return that.$dialog.toast({mes: this.$t('message.withdrawal.msg_fill_data')});
                }
                if (!that.phone) {
                    return that.$dialog.toast({mes: this.$t('message.withdrawal.msg_phone')});
                }

                if (!money) {
                    return that.$dialog.message(this.$t('message.withdrawal.msg_withdraw_amount'));
                }

                if (parseFloat(money) > parseFloat(that.userInfo.now_money) || parseFloat(that.userInfo.now_money) === 0)
                    return that.$dialog.message(this.$t('message.withdrawal.msg_insufficient_balance'));
                if (parseFloat(money) < parseFloat(that.minPrice))
                    return that.$dialog.message(this.$t('message.withdrawal.msg_minimum') + " " + that.minPrice + " " + this.$t('message.withdrawal.msg_to_withdraw'));

                // 判断是否添加提现密码
                // console.log(that.is_set_pwd)
                if (!that.is_set_pwd) {
                    this.$dialog.confirm({
                        mes: "₫ặt mật khẩu rút tiền ₫ể ₫ảm bảo tiền tài khoản an toàn hơn",
                        title: "₫ặt mật khẩu rút tiền",
                        opts: [
                            {
                                txt: "Chắc chắn rồi",
                                color: "#00C3F9",
                                callback: () => {
                                    that.$router.replace({
                                        path: "/user/myPay"
                                    })
                                }
                            },
                            {
                                txt: "Hủy bỏ",
                                color: false,
                                callback: () => {
                                    return that.$dialog.toast({mes: "Cancelled"});
                                }
                            }
                        ]
                    })
                } else {
                    that.yz_pwd = true
                }
                // return
                /*let save = {
                    cash_id: cash_id,
                    money: money,
                    // wallet_type: this.wallet_type
                };*/
                //发起提现
                // console.log(save)
                // return
                // that.save(save);
            },
            save: function (info) {
                if (this.bomb_submit) {
                    return
                }

                this.bomb_submit = true
                this.$dialog.loading.open("Loading...");

                user_withdraw(info).then(
                    res => {
                        this.$dialog.loading.close();
                        this.bomb_submit = false
                        this.$dialog.message(res.msg);
                        this.$router.push({path: "/user/audit"});
                    },
                    error => {
                        this.$dialog.loading.close();
                        this.bomb_submit = false
                        this.$dialog.message(error.msg);
                    }
                );
            },
            getWithdrawPassword() {
                let that = this
                getWithdrawPasswordFlag().then(res => {
                    that.is_set_pwd = res.data.flag
                    // that.is_set_pwd = true
                }).catch(res => {
                    this.$dialog.error('nhận ngoại lệ');
                })
            },
            inputPassword() {
                if (this.withdraw_pwd === '') {
                    return this.$dialog.error('Mật khẩu rút tiền không ₫ược ₫ể trống')
                }
                let param = {
                    cash_id: this.cash_id,
                    money: this.post.money,
                    withdraw_pwd: this.withdraw_pwd
                }
                // console.log(param)
                this.save(param)
            },
            bgClose() {
                this.withdraw_pwd = ''
                this.yz_pwd = false
            },
            forgetPassword() {
                this.$router.push({path: "/user/myPay"});
            },
        }
    };
</script>
<style scoped>
    .cash-withdrawal {
        padding: 0.3rem;
        box-sizing: border-box;
        /*background: #FAFAFA;*/
    }

    .row-T1 {
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        padding-left: 0.27rem;
        box-sizing: border-box;
    }

    .row-info {
        width: 100%;
        height: 0.5rem;
        line-height: 0.5rem;
        padding-left: 0.27rem;
        box-sizing: border-box;
        color: #999;
        margin-top: -10px;
    }

    .row-error {
        width: 100%;
        box-sizing: border-box;
        color: #ff3c2b;
        margin-top: -10px;

    }

    .value-item {
        width: 100%;
        /*height: 5rem;*/
        background: #fff;
        padding: 0.27rem 0.27rem 0 0.27rem;
        box-sizing: border-box;
        margin-top: 0.3rem;
        margin-bottom: 0.3rem;
    }

    .value-item .flex {
        display: flex;
        width: 100%;
        height: 1.2rem;
        border-bottom: 1px solid #eee;
    }

    .value-item .T1 {
        width: 100%;
        height: 0.6rem;
        line-height: 0.6rem;
    }

    .value-item .flex .I1 {
        width: 0.4rem;
        font-size: 0.85rem;
        line-height: 1.2rem;
        height: 1.2rem;
    }

    .value-item .flex input {
        width: 6rem;
        border: none;
        line-height: 1.2rem;
        height: 1.2rem;
        font-size: 0.65rem;
        padding-left: 0.25rem;
        box-sizing: border-box;
    }

    .value-item .max {
        width: 100%;
        line-height: 1rem;
        height: 1rem;
    }

    .value-item .min {
        width: 100%;
        line-height: 0.5rem;
        height: 0.5rem;
    }

    .href {
        color: #0c7cd8;
    }

    .row-wrap {
        /*margin-bottom: 0.3rem;*/
    }

    .row {
        width: 100%;
        padding: 0 0.27rem;
        box-sizing: border-box;
        background: #fff;
        height: 0.75rem;
        line-height: 0.75rem;
        display: flex;
        position: relative;
    }

    .row::after {
        content: "";
        position: absolute;
        width: calc(100% - 0.27rem - 0.27rem);
        bottom: 0px;
        left: 0;
        right: 0;
        margin: 0 auto;
        height: 1px;
        background: #eee;
    }

    .row .row-name {
        width: 2.5rem;
    }

    .row .input {
        flex: 1;
        display: block;
        height: 0.75rem;
        line-height: 0.75rem;
        box-sizing: border-box;
        padding-left: 0.15rem;
        border: none;
        background: #fff;
    }

    .row .select {
        flex: 1;
        display: block;
        height: 0.75rem;
        line-height: 0.75rem;
        box-sizing: border-box;
        padding-left: 0.15rem;
        border: none;
        background: #fff;
    }

    .submit {
        width: 100%;
        height: 0.92rem;
        background: rgba(0, 195, 249, 1);
        border-radius: 7px;
        color: #fff;
        line-height: 0.92rem;
        text-align: center;
        font-size: 0.35rem;
        margin-top: 1rem;
    }


    .money-switch {
        width: 100%;
        display: flex;
        flex-wrap: wrap;


        box-sizing: border-box;
        background: #fff;
        border-radius: 3px;
        flex-direction: row;
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
    }

    .money-switch .switch-item {
        width: 48%;
        border: 1px solid #ccc;
        border-radius: 3px;
        margin-bottom: 10px;
        line-height: 50px;
        height: 50px;
        /* margin-right: 10px; */
        color: #333;
        font-size: 0.36rem;
        text-align: center;

    }

    .money-switch .switch-item:nth-child(3n) {
        margin-right: 0px;
    }

    .switch-click {
        border: 1px solid #00c3f9 !important;
        color: #00c3f9 !important;

    }

    .switch-info {
        margin-bottom: 10px;
        color: #666;
        /*text-align: center;*/
    }

    .text_title {
        text-align: center;
        margin-top: -3px;
        margin-bottom: 2.5px;
        color: red;
    }

    .text_title i {
        font-size: .2rem;
    }

    #forPop {
        z-index: 999;
        width: 100%;
        height: 1000px;
        top: 0px;
        left: 0px;
        position: absolute;
        /*因为IE不支持opacity 所以用filter 为了兼容两个都写*/
        filter: Alpha(opacity=60);
        opacity: 0.6;
        background: #000000;
    }

    .set-pwd {
        z-index: 1000;
        background-color: #fff;
        width: 350px;
        height: auto;
        border-radius: 5px;
        /*border: #888888 2px solid;*/
        position: fixed;
        left: 50%;
        top: 50%;
        margin-top: -210px;
        margin-left: -175px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .set-tx-pwd-btn {
        display: block;
        width: 2.5rem;
        height: 0.86rem;
        margin: 0.2rem;
        float: left;
        line-height: 0.86rem;
        text-align: center;
        color: #fff;
        border-radius: 0.15rem;
        font-size: 0.3rem;
        font-weight: bold;
    }

    .bg-qx {
        background-color: #f0f1f3;
    }

    .tx-pwd-title {
        font-weight: bold;
        text-align: center;
    }

    .forget-password {
        color: #ddd;
        text-align: right;
        padding-right: 0.2rem;
    }

</style>
